import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import AddZoomMeet from "../../components/ZoomMeetings/AddZoomMeeting";


const AddZoomMeetings = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Zoom Meetings  </h5><Breadcrumb title="Add Zoom Meetings" /></div>


        {/* AddUserLayer */}
        <AddZoomMeet />


    </>
  );
};

export default AddZoomMeetings;